module.exports = __webpack_public_path__ + "img/IssuePage.acbe3ce5.png";